import React, { useState } from 'react';
import classNames from 'classnames';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { ButtonColor, ButtonType, CustomButton } from 'Douleutaras/components/CustomButton/CustomButton';
import { email as emailValidator } from 'Douleutaras/components/Forms/Validators';

interface FormValues {
  email: string;
}

const NewsletterSubscribeForm = () => {
  const [submissionSuccessfulMessage, setSubmissionSuccessfulMessage] = useState('');
  const { t } = useTranslation();
  const formErrorMessage = t('A server error occurred while trying to submit the form or e-mail is not valid. ' +
    'Please try again or contact our support');
  const backupSuccessMessage = t('Success');

  const { register, handleSubmit, formState: { invalid, errors }, setError } = useForm<FormValues>({
    mode: 'onSubmit'
  });

  const onSubmit = async ({ email }: FormValues) => {
    try {
      const response = await axios.post('/blog/subscribe', {
        email,
        from_blog: false
      });
      const successMessage = response.data.length > 1
        ? response.data
        : backupSuccessMessage;

      setSubmissionSuccessfulMessage(successMessage);
    } catch (error) {
      setError('email', { type: 'server', message: formErrorMessage });
    }
  };

  return (
    <div className="footer-subscribe">
      <h6 className="footer-subscribe__title">
        {t('Subscribe to our newsletter')}
      </h6>

      {submissionSuccessfulMessage.length > 1
        ?
        (<p className="footer-subscribe__success">
          {submissionSuccessfulMessage}
        </p>)
        :
        (
          <form className="footer-subscribe__form" onSubmit={handleSubmit(onSubmit)} autoComplete="off" noValidate>
            <div className="footer-subscribe__input">
              <div className={
                classNames(['custom-input-wrapper'], { 'show-error': Boolean(errors.email?.message) })
              }>
                <input
                  className="line-input line-input--small line-input--transparent"
                  type="email"
                  placeholder="Email"
                  {...register('email', {
                    validate: {
                      email: value => emailValidator(value, t('T.VALIDATOR.Wrong email specified'))
                    }
                  })}
                />
                <span className="line-input-error">
                  {errors.email?.message as string}
                </span>
              </div>
            </div>
            <div className="footer-subscribe__submit">
              <CustomButton
                disabled={invalid}
                title={t('Sign up')}
                color={ButtonColor.LIGHTBLUE}
                type={ButtonType.SUBMIT}
              />
            </div>
          </form>
        )
      }
    </div>
  );
};

export default NewsletterSubscribeForm;
